<footer [class]="layout">
  <div class="footer-overlay" [style.background]="color">
    <div class="container position-relative">
      <div class="row">
        <div class="col-lg-4 col-md-7">
          <div class="footer-item-one">
            <a class="logo-img" href="#">
              <img
                style="width: 18rem"
                [src]="'assets/img/app/good-tsagaan.png'"
                alt=""
            /></a>
            <br />
            <a class="mt-25 links" routerLink="/about">{{
              "about" | translate
            }}</a
            ><br />
            <a class="links" routerLink="/privacy">{{
              "privacy" | translate
            }}</a
            ><br />
            <a class="links" routerLink="/get-service-merchant">{{
              "getService" | translate
            }}</a
            ><br />
            <a class="links" routerLink="/news">{{ "news" | translate }}</a
            ><br />
            <a class="links" routerLink="/faq-merchant">{{
              "faq" | translate
            }}</a>
          </div>
        </div>
        <div class="col-lg-2 offset-lg-1 col-md-5"></div>
        <div class="col-lg-5 col-md-6">
          <div class="footer-wid mt-30">
            <div class="row contactus justify-content-center cont-item">
              <div class="col-lg-12 col-sm-12">
                <div class="col-2"></div>
                <div class="col-lg-10 col-sm-12">
                  <h4>{{ "contactUs" | translate }}</h4>
                </div>
              </div>
            </div>
            <div class="row mt-30 cont-item">
              <div class="col-lg-12 col-sm-9">
                <div class="row">
                  <div class="col-2">
                    <img src="/assets/img/app/call.png" />
                  </div>
                  <div class="col-10"><span>+976 7600-7711</span><br /></div>
                </div>
              </div>
            </div>
            <div class="row mt-10 cont-item">
              <div class="col-lg-12 col-sm-9">
                <div class="row">
                  <div class="col-2">
                    <img src="/assets/img/app/email.png" />
                  </div>
                  <div class="col-10"><span>info@scopa.mn</span><br /></div>
                </div>
              </div>
            </div>
            <div class="row mt-10 cont-item">
              <div class="col-lg-12 col-sm-9">
                <div class="row">
                  <div class="col-2">
                    <img src="/assets/img/app/location.png" />
                  </div>
                  <div class="col-10">
                    <span [innerHTML]="'address' | translate"></span
                    ><br />
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-center mt-20">
              <div class="col-lg-2 col-sm-1"></div>
              <div class="col-2">
                <a
                  href="https://www.facebook.com/GOOD-platform-108353818407205"
                  target="_blank"
                >
                  <img src="/assets/img/app/facebook.png"
                /></a>
              </div>
              <div class="col-2">
                <a
                  href="https://www.linkedin.com/company/goodplatform"
                  target="_blank"
                >
                  <img src="/assets/img/app/linkedin.png"
                /></a>
              </div>
              <div class="col-2">
                <a href="https://twitter.com/platform_good" target="_blank">
                  <img src="/assets/img/app/twitter.png"
                /></a>
              </div>
              <div class="col-2">
                <a
                  href="https://www.instagram.com/goodgood.mn/"
                  target="_blank"
                >
                  <img src="/assets/img/app/instagram.png"
                /></a>
              </div>
              <div class="col-2">
                <a
                  href="https://www.youtube.com/channel/UCD4HxYvPLxsogWrZVoVGa8Q"
                  target="_blank"
                >
                  <img src="/assets/img/app/youtube.png"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="footer-copyright">
            <p><span>SCOP ALLIANCE LLC</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
<div class="back-to-top back-to-top-2" id="backToTop">
  <a
    href="javascript:void(0)"
    *ngIf="isShow"
    (click)="gotoTop()"
    (window:scroll)="ScrolltoTop()"
  >
    <i class="fas fa-arrow-up"></i>
  </a>
</div>
